<template>
  <el-table-column
    prop="user.full_name"
    label="Felhasználó"
    min-width="100"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.user.full_name }}
    </template>
  </el-table-column>
</template>
<script>
export default {
  propName: 'username',
};
</script>
